import jsPDF from 'jspdf';
import 'jspdf-autotable';
import logo from "../img/logo.jpg";

export const generatePDF = (order: any) => {
  const doc = new jsPDF();

  // Add Receipt Header
  doc.setFontSize(20);
  doc.text("RECEIPT", 15, 20);

  // Add Company Details
  doc.setFontSize(12);
  doc.text("COZY BUD (PVT) LTD", 15, 30);

  // Add Payment Details
  doc.text("Order Date:", 150, 30, { align: "right" });
  doc.text(`${new Date(order.order_date.seconds * 1000).toLocaleString()}`, 195, 30, { align: "right" });

  doc.text("Tracking Number:", 150, 40, { align: "right" });
  doc.text(`${order.tracking_number || "N/A"}`, 195, 40, { align: "right" });

  doc.text("Payment Method:", 150, 50, { align: "right" });
  doc.text(`${order.payment_method || "N/A"}`, 195, 50, { align: "right" });

  doc.text("Courier Charge:", 150, 60, { align: "right" });
  doc.text("LKR 400.00", 195, 60, { align: "right" });

  // Add Logo Placeholder (You can replace this with an actual image)
  doc.addImage(logo, 'JPG', 15, 40, 25, 25);

  var tableData: any = []
  order.items.forEach((item: any) => {
  // Add Table Section
  tableData.push(
    {
      itemName: item.item_name,
      color: item.color,
      size: item.size,
      quantity: item.quantity.toString(),
      unitPrice: `LKR ${item.unit_price.toFixed(2)}`,
      totalPrice: `LKR ${item.total_price.toFixed(2)}`,
    });
  });
  doc.autoTable({
    startY: 100,
    head: [
      [
        "Item Name",
        "Color",
        "Size",
        "Quantity",
        "Unit Price",
        "Total Price",
      ],
    ],

    body: tableData.map((row:any) => [
      row.itemName,
      row.color,
      row.size,
      row.quantity,
      row.unitPrice,
      row.totalPrice,
    ]),
  
    theme: "grid",
    headStyles: {
      fillColor: [127, 190, 235], // Change this to any RGB color
      textColor: [255, 255, 255], // White text color
      fontStyle: "bold",
    },
    styles: {
      fontSize: 10,
    },
  });

  // Add Total Section
  const finalY = doc.lastAutoTable.finalY || 120;
  doc.setFontSize(12);
  doc.text("Total Price:", 160, finalY + 10, { align: "right" });
  doc.text(`LKR ${order.total_price.toFixed(2)}`, 195, finalY + 10, { align: "right" });

  return doc;
};
